var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1422_55707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1422_55707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.0627L16.1253 5.93767C16.3337 5.72934 16.5802 5.62865 16.8649 5.63559C17.1496 5.64253 17.3962 5.75017 17.6045 5.95851C17.8128 6.16684 17.917 6.41337 17.917 6.69809C17.917 6.98281 17.8128 7.22934 17.6045 7.43767L11.1878 13.8335C11.0212 14.0002 10.8337 14.1252 10.6253 14.2085C10.417 14.2918 10.2087 14.3335 10.0003 14.3335C9.79199 14.3335 9.58366 14.2918 9.37533 14.2085C9.16699 14.1252 8.97949 14.0002 8.81283 13.8335L2.39616 7.41684C2.18783 7.20851 2.08713 6.96545 2.09408 6.68767C2.10102 6.4099 2.20866 6.16684 2.41699 5.95851C2.62533 5.75017 2.87185 5.64601 3.15658 5.64601C3.4413 5.64601 3.68783 5.75017 3.89616 5.95851L10.0003 12.0627Z",
    fill: "#01BCD4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1fce02eaaa17c7702bd2711966f1063b.svg";
export { ForwardRef as ReactComponent };